import {IAccountGroup} from '../../shared/types/user-account-groups.types';
import {AccountGroupsService} from '../services/user-account-groups.service';
import {ISelectOption} from './option.type';

export interface IGroupSelectOption extends Pick<ISelectOption, 'label'> {
  value: IAccountGroup;
}

export const searchGroupStrategy = async (str: string) => {
  const {
    data: {content},
  } = await AccountGroupsService.getAll({
    spec: {
      name: str.trim(),
    },
  });

  if (content.length) {
    return content.map((i) => ({value: i, label: i.name})) as IGroupSelectOption[];
  }

  return [];
};
